import config from '../configs/BaseConfig';
import common from '../commons/BaseCommon';
import request from '../utils/request';
import {showLoading} from "../components/Modal/GlobalLoading";


//登录
export async function login(params, callback){
    showLoading();
    let reqObj = common.functionCommon.getPostReqObj(config.dataServer, config.urlConfig.loginUrl.login, params);
    const response = await request(reqObj.reqUrl, reqObj.options,"用户登录");
    common.functionCommon.processResponse(response, callback,"用户登录");
}
//是否授权过
export async function isAuth(params, callback){
    let reqObj = common.functionCommon.getPostReqObj(config.dataServer, config.urlConfig.loginUrl.isAuth, params);
    const response = await request(reqObj.reqUrl, reqObj.options);
    common.functionCommon.processResponse(response, callback);
}
//登录有效性检测
export async function checkLogin(params, callback){
    let reqObj = common.functionCommon.getPostReqObj(config.dataServer, config.urlConfig.loginUrl.checkLogin, params);
    const response = await request(reqObj.reqUrl, reqObj.options);
    common.functionCommon.processResponse(response, callback);
}
//退出登录
export async function logOut(params, callback){
    showLoading();
    let reqObj = common.functionCommon.getPostReqObj(config.dataServer, config.urlConfig.loginUrl.logOut, params);
    const response = await request(reqObj.reqUrl, reqObj.options,"注销登录");
    common.functionCommon.processResponse(response, callback,"注销登录");
}